
/**
 * Middleware for transforming Typed Actions into plain actions since redux
 * checks for is-plain-object
 */
export const typedToPlain = (store: any) => (next: any) => (action: any) => {
  next((Object as any).assign({}, action));
};
